import FingerprintIcon from "@mui/icons-material/Fingerprint";
import FolderIcon from "@mui/icons-material/FolderOpen";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import SearchIcon from "@mui/icons-material/Search";
import {
    Breadcrumbs,
    Button,
    CircularProgress,
    FilledInput,
    FormControl,
    InputAdornment,
    Link,
    Menu,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {withStyles} from "@mui/styles";
import axios from "axios";
import * as React from "react";
import {Redirect} from "react-router-dom";

import {StaticModal} from "../../../../components/ConfrimDialog";
import {Config} from "../../../../config/config";
import {Helpers} from "../../../../utils/helpers";
import {PopupMessage} from "../../../../utils/message";
import {NewFileModalForm} from "../CreateFile";
import {NewFolderModalForm} from "../CreateFolder";
import "./style.scss";

interface FilesPageStates {
    redirect: boolean;
    data: any;
    breadCrumbs: any[];
    loaded: boolean;
    haveError: boolean;
    currentPath: string;
    rootPage: boolean;
    bundleId: string;
    bundleData: any;
    newFolderModalVisible: boolean;
    filesToDelete: any[];
    weapons: any[];
    weaponsLoaded: boolean;
    anchorEl: any;
    menuVisible: boolean;
    activeRenamePlaceholder: any;
    searchKeyword: null | string;
    fileSource: string;
    savingFileName: null | string;
    loading: boolean;
}

// List with files we should hide
const filesToHide = [
    "attachments/list.json",
    "localization",
    "achievements/achievements.json",
    "achievements/daily_jobs.json",
    "achievements/game.json",
    "achievements/jobs.json",
    "events/types",
    "chests",
    "families/game.json",
    "families/benefits.json",
    "families/contracts.json",
    "flags",
    "items/list.json"
];

class BundleExplorerMain extends React.Component<{activeUser: any; classes: any; history: any}, FilesPageStates> {
    timeout: number;

    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            newFolderModalVisible: false,
            bundleId: "base",

            bundleData: null,

            currentPath: this.urlWithBasePath(props.match.url),

            data: null,
            breadCrumbs: [],
            loaded: false,
            haveError: false,
            rootPage: (!props.match.params.folder1),

            filesToDelete: [],

            weapons: [],
            weaponsLoaded: false,

            anchorEl: null,
            menuVisible: false,

            activeRenamePlaceholder: null,

            searchKeyword: null,
            fileSource: "game",
            savingFileName: null,

            loading: false
        };

        // Listen changes so correct data could be seen
        this.props.history.listen((location) => {
            this.changePath(location.pathname);
        });

        document.title = Helpers.documentTitle("Config files");
    }

    /**
     * Remove route name from url to get structure of folders
     */
    urlWithBasePath = (url) => {
        let base = url.replace("/bundle/", "").replace("/bundle", "");

        if (base.slice(-1) !== "/") {
            base += "/";
        }

        return base;
    };

    componentDidMount() {
        // Load bundle data and then load bundle content
        this.loadBundleData(() => {
            this.loadFolderContent();
        });

        if (this.isWeaponsPath()) {
            this.getWeaponsConfig();
        }
    }

    generateFingerprint = () => {
        const messageAlert = PopupMessage.loading("Generating fingerprint file...");

        axios.post(`${Config.getInstance.apiUrl}/api/bundle/generate_fingerprint`, {
            bundle: this.state.bundleId,
        }, {
            headers: {
                Authorization: Helpers.getSessionId(),
            },
        }).then(() => {
            messageAlert(() => {
                //
            });
        }).catch(() => {
            messageAlert(() => {
                PopupMessage.error("Something went wrong");
            });
        });
    };

    getWeaponsConfig = () => {
        axios.get(`${Config.getInstance.apiUrl}/api/items/type/weapons`, {
            headers: {
                Authorization: Helpers.getSessionId(),
            },
        }).then((result) => {
            this.setState({
                weapons: result.data.data,
                weaponsLoaded: true,
            });
        }).catch(() => {
            // If error then reset graph options
            this.setState({
                haveError: true,
                weaponsLoaded: true,
            });
        });
    };

    changePath = (path) => {
        this.setState({
            currentPath: this.cleanPathName(path),
            rootPage: (this.cleanPathName(path) === "/"),
        });
    };

    cleanPathName(link) {
        let currentPath = link.replace("/bundle/", "");
        if (currentPath.slice(-1) !== "/") {
            currentPath += "/";
        }
        return currentPath;
    }

    /**
     * Get bundle data based on bundle ID
     */
    loadBundleData = (cb) => {
        axios.get(`${Config.getInstance.apiUrl}/api/bundle`, {
            headers: {
                Authorization: Helpers.getSessionId(),
            },
        }).then((result) => {
            this.setState({
                bundleData: result.data.data,
            }, cb());
        }).catch(() => {
            // If error then reset graph options
            this.setState({
                haveError: true,
            });
        });
    };

    addRootFolders(data) {
        return data.reduce((allData, item) => {
            const splitedData = item.Key.split("/");
            // quick fix
            if (item.Key.indexOf(".") === -1 && splitedData.length - 1 === 1) {
                return allData;
            }

            if (splitedData.length > 1) {
                splitedData.pop();

                splitedData.reduce((allFolders, splitedItem) => {
                    const lastFolder = allFolders[allFolders.length - 1] || "";
                    const folder = `${lastFolder}${splitedItem}/`;
                    const rootObject = allData.find(item1 => item1.Key === folder);

                    if (!rootObject) {
                        allData.push({
                            Key: folder,
                            LastModified: item.LastModified,
                            Size: +item.Size,
                            StorageClass: "STANDARD",
                        });
                    } else {
                        if (new Date(rootObject.LastModified).getTime() < new Date(item.LastModified).getTime()) {
                            rootObject.LastModified = item.LastModified;
                        }

                        rootObject.Size += item.Size;
                    }

                    allFolders.push(folder);
                    return allFolders;
                }, []);
            }

            allData.push(item);

            return allData;
        }, []);
    }

    /**
     * Get list with bundle files
     */
    loadFolderContent() {
        this.setState({loaded: false}, () => {
            axios.post(`${Config.getInstance.apiUrl}/files`, {source: this.state.fileSource}).then(result => {
                this.setState({
                    loaded: true,
                    data: this.addRootFolders(result.data.data),
                    breadCrumbs: result.data.bread_crumbs,
                });
            }).catch(() => {
                // If error then reset graph options
                this.setState({
                    loaded: true,
                    haveError: true,
                });
            });
        });
    }

    getObjectData(key) {
        if (!this.state.bundleData || !this.state.bundleData.objects) {
            return null;
        }
        const objectData = this.state.bundleData.objects.find(
            object => object.key === key);

        if (!objectData) {
            return null;
        }

        return objectData;
    }

    openSheet = (e) => {
        e.preventDefault();

        this.closeRowMenu();

        const driveKey = e.target.attributes.getNamedItem("drive-key").value;
        const win = window.open(`https://docs.google.com/spreadsheets/d/${driveKey}/edit`, "_blank");

        if (win) {
            win.focus();
        }
    };

    editFile = (e, hash = null) => {
        if (e) {
            e.preventDefault();
        }

        this.closeRowMenu();

        const objectHash = e ? e.target.attributes.getNamedItem("object-hash").value : null;

        this.props.history.push(`/bundle/item/${hash || objectHash}?source=${this.state.fileSource}`);
    };

    downloadJson = (e) => {
        e.preventDefault();

        this.closeRowMenu();

        const objectKey = e.target.attributes.getNamedItem("object-key").value;
        const url = `https://s3.eu-west-3.amazonaws.com/staging-mavia-logic/${objectKey}`;

        setTimeout(() => {
            window.open(url);
        }, 100);
    };

    exportFolderContent = async (e) => {
        e.preventDefault();

        const objectKey = e.target.attributes.getNamedItem("object-key").value;
        const folderPath = objectKey.replace(this.state.bundleId + "/", "");
        const loading = PopupMessage.loading("Exporting folder content. Please be patient...");

        try {
            this.setState({anchorEl: null, menuVisible: false});

            const response = await axios.post(`${Config.getInstance.apiUrl}/api/bundle/export_folder`, {
                bundleId: this.state.bundleId,
                folderPath,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    objectKey,
                },
                timeout: 300000,
            });

            loading(() => {
                PopupMessage.success(`Files from ${folderPath.substring(0, folderPath.length - 1)} exported!`);
            });
        } catch (error) {
            loading(() => {
                PopupMessage.error(`Couldn't export files from ${folderPath.substring(0, folderPath.length - 1)}`);
            });
        }
    };

    deleteObject = (e) => {
        e.preventDefault();

        const objectKey = e.target.attributes.getNamedItem("object-key").value;
        // tslint:disable-next-line:no-this-assignment
        const parent = this;

        this.setState({anchorEl: null, menuVisible: false});

        // Show confirmation pop up
        StaticModal.confirm({
            title: "Are you sure delete this file?",
            content: "Once you delete this bundle, it cannot be undone.",
            okText: "Delete",
            cancelText: "Cancel",
            async onOk() {
                const messageAlert = PopupMessage.loading("Deleting file...");

                // Call delete method
                axios.delete(`${Config.getInstance.apiUrl}/api/bundle/file`, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                        objectKey,
                    },
                }).then((response: any) => {
                    messageAlert(() => {
                        if (response) {
                            parent.refreshList();
                        } else {
                            PopupMessage.error("Something went wrong");
                        }
                    });
                }).catch(() => {
                    messageAlert(() => {
                        PopupMessage.error("Something went wrong");
                    });
                });
            },
        });
    };

    openRowMenu = (event) => this.setState({anchorEl: event.currentTarget}, () => this.setState({menuVisible: true}));
    /**
     * For menu closing we have two functions to make animations smoother
     */
    closeRowMenu = () => this.setState({menuVisible: false});
    clearMenuAnchor = () => this.setState({anchorEl: null});

    saveFilePlaceholder(e, file) {
        // Call delete method
        this.setState({savingFileName: file}, async () => {
            await axios.put(`${Config.getInstance.apiUrl}/api/bundle/object`, {
                name: e.target.value,
                bundleId: this.state.bundleId,
                file,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            this.setState({
                savingFileName: null,
            });
        });
    };

    changeFilePlaceholder = (e, file) => {
        if (this.state.bundleData) {
            const tempObjects = [...this.state.bundleData.objects];
            const objectIndex = tempObjects.findIndex(item => item.key === file);

            if (objectIndex > -1) {
                tempObjects[objectIndex].name = e.target.value;
            } else {
                tempObjects.push({
                    description: null,
                    drive_key: null,
                    key: file,
                    name: e.target.value,
                    type: "file",
                });
            }

            this.setState(prevState => ({
                bundleData: {
                    ...prevState.bundleData!,
                    objects: tempObjects,
                },
            }));
        }
    };

    inlineTableEdit = (file) => {
        if (this.pathIsFolder(file.Key)) {
            return this.getFileName(file);
        }

        if (this.state.savingFileName === file.Key) {
            return <CircularProgress size={25} />;
        }

        return <div>
            <FilledInput
                value={this.getFileName(file)}
                className="inline-edit-input"
                onBlur={e => this.saveFilePlaceholder(e, file.Key)}
                onChange={e => this.changeFilePlaceholder(e, file.Key)}
                onClick={e => e.stopPropagation()}
                style={{width: "80%"}}
            />
        </div>;
    };

    getFolderName = (key) => {
        const structure = key.split("/");
        structure.splice(-1, 1);

        return structure.join("/");
    };

    formatFilesToTable = (data) => {
        if (!this.state.loaded) {
            return <TableRow key="loading-row">
                <TableCell colSpan={7}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>;
        }

        const {classes} = this.props;

        let cleanList = this.filterFileType(this.filterActiveFilesByPath(data));

        if (this.state.rootPage) {
            cleanList = this.sortFilesAlphabetically(cleanList);
        }

        return cleanList.map(file => (
            <TableRow key={file.Key} hover={true} onClick={event => this.handleRowClick(event, file)}
                className={classes.tableRow}>
                <TableCell>{this.getPathIcon(file)}</TableCell>
                <TableCell>{this.inlineTableEdit(file)}</TableCell>
                {this.showGameId() && <TableCell style={{width: 150}}>{this.getFileGameId(file)}
                </TableCell>}
                <TableCell>{this.getFileType(file)}</TableCell>
                <TableCell>{this.getFileSize(file)}</TableCell>
                <TableCell>{Helpers.formatDateWithTime(file.LastModified)}</TableCell>
                <TableCell>{file.Key}</TableCell>
                {this.state.searchKeyword && <TableCell>{this.getFolderName(file.Key)}</TableCell>}
                <TableCell style={{textAlign: "right"}}>
                    <IconButton
                        aria-label="More"
                        aria-haspopup="true"
                        onClick={this.openRowMenu}
                        file-key={file.Key}
                        file-hash={file.Hash}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        ));
    };

    formatTableBody = (data) => {
        if (this.state.loaded && data.length === 0) {
            return <div className="no-items-placeholder">
                <NotInterestedIcon />
                <h3>No data to display</h3>
            </div>;
        }

        return <React.Fragment>
            <Table className="min-table-size">
                <TableHead>
                    <TableRow>
                        <TableCell style={{width: 20}}></TableCell>
                        <TableCell style={{width: 400}}>Name</TableCell>
                        {this.showGameId() && <TableCell style={{width: 100}}>Game Id</TableCell>}
                        <TableCell style={{width: 150}}>Type</TableCell>
                        <TableCell style={{width: 150}}>Size</TableCell>
                        <TableCell style={{width: 200}}>Last modified</TableCell>
                        <TableCell style={{width: 200}}>Path</TableCell>
                        {this.state.searchKeyword && <TableCell style={{width: 150}}>Folder</TableCell>}
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.formatFilesToTable(data)}
                </TableBody>
            </Table>
            <Menu
                id="long-menu"
                anchorEl={this.state.anchorEl}
                open={this.state.menuVisible}
                onClose={this.closeRowMenu}
                TransitionProps={{
                    onExited: this.clearMenuAnchor
                }}
            >
                {this.getFileActions()}
            </Menu>
        </React.Fragment>;
    };

    filterFileType = (list: any[]) =>
        list.sort((a, b) => {
            if (this.pathIsFolder(a.Key)) {
                return -1;
            }

            return 1;
        });

    sortFilesAlphabetically = (list: any[]) =>
        list.sort((a, b) => {
            if (this.getFileName(a) < this.getFileName(b)) {
                return -1;
            }

            if (this.getFileName(a) > this.getFileName(b)) {
                return 1;
            }

            return 0;
        });

    handleRowClick(event, file) {
        const fileName = file.Key;

        // Allow to switch between folders when clicking on row, not buttons etc
        if (!event.target.classList.value.includes("MuiSvgIcon") && this.pathIsFolder(fileName)) {
            if (fileName.indexOf("bounties") > -1) {
                this.props.history.push("/bounties/packs");
                return;
            }

            this.setState({currentPath: fileName});
            this.props.history.push(Helpers.fullUrl(fileName));
        }

        // If clicked on file
        if (!event.target.classList.value.includes("MuiSvgIcon") && !this.pathIsFolder(fileName)) {
            if (this.isMissionsPath(fileName) && this.state.bundleData) {
                const name = this.cleanFileName(fileName).split(".")[0];
                const missionUrl = `/map/edit/${this.state.bundleId}/${this.getMissionType()}/${name}`;

                this.props.history.push(missionUrl);
                return;
            }

            const fileType = this.cleanFileName(fileName).split(".");
            const fileExtension = fileType[fileType.length - 1];
            const objectData = this.getObjectData(fileName);

            if ((fileExtension === "JSON" || fileExtension === "json")) {
                if (objectData && objectData.drive_key && this.canUserGoogleSheet(fileName)) {
                    const win = window.open(`https://docs.google.com/spreadsheets/d/${objectData.drive_key}/edit${objectData.gid ? `#gid=${objectData.gid}` : ""}`, "_blank");
                    if (win) {
                        win.focus();
                    }
                } else {
                    this.editFile(null, file.Hash);
                }
            }
        }
    };

    /**
     * List with paths where google sheets are disabled
     */
    // canUserGoogleSheet = (fileName) =>
    //     fileName.indexOf("families/game.json") === -1 &&
    //     fileName.indexOf("families/contracts.json") === -1 &&
    //     fileName.indexOf("flags") === -1 &&
    //     fileName.indexOf("districts/game.json") === -1 &&
    //     fileName.indexOf("districts/milestones.json") === -1 &&
    //     fileName.indexOf("rockets") === -1 &&
    //     fileName.indexOf("achievements/achievements.json") === -1 &&
    //     fileName.indexOf("achievements/daily_jobs.json") === -1 &&
    //     fileName.indexOf("achievements/game.json") === -1 &&
    //     fileName.indexOf("achievements/jobs.json") === -1 &&
    //     fileName.indexOf("events/mods.json") === -1 &&
    //     fileName.indexOf("chests/data/") === -1 &&
    //     fileName.indexOf("chests") === -1;

    canUserGoogleSheet = (_) => false;

    /**
     * Show game id for files in these folders
     */
    showGameId = () =>
        this.state.currentPath.indexOf("weapons") !== -1 ||
        this.state.currentPath.indexOf("armors") !== -1 ||
        this.state.currentPath.indexOf("buildings") !== -1 ||
        this.state.currentPath.indexOf("Artillery") !== -1 ||
        this.state.currentPath.indexOf("decorations") !== -1 ||
        this.state.currentPath.indexOf("heros") !== -1 ||
        this.state.currentPath.indexOf("shields") !== -1 ||
        this.state.currentPath.indexOf("obstacles") !== -1 ||
        this.state.currentPath.indexOf("Followers") !== -1 ||
        this.state.searchKeyword;

    handleBreadcrumbLink = (event) => {
        event.preventDefault();
        const fileName = this.urlWithBasePath(event.target.getAttribute("href"));

        this.setState({currentPath: fileName});
        this.props.history.push(Helpers.fullUrl(fileName));
    };

    getFileDepth = (file) => {
        const fileStructure = file.split("/");
        const isFolder = this.pathIsFolder(file) ? 0 : 1;
        return fileStructure.length + isFolder;
    };

    pathIsFolder = (file) => {
        const fileStructure = file.split("/");
        const lastStructureItem = fileStructure[fileStructure.length - 1];
        // If last item after split is empty it means it's folder... probably
        return lastStructureItem.length === 0;
    };

    filterActiveFilesByPath = (data) => {
        if (this.state.searchKeyword) {
            const lowercaseKeyword = this.state.searchKeyword;

            return data.filter(file =>
                file.Key.toLowerCase().indexOf(lowercaseKeyword) > -1 ||
                this.getFileName(file).toLowerCase().indexOf(lowercaseKeyword) > -1
            );
        }

        const currentPathDepth = this.state.currentPath.split("/").length;

        const checkFile = (file) => {
            // If root path
            if (this.state.currentPath === "/") {
                return currentPathDepth === this.getFileDepth(file.Key) - (this.state.currentPath === "/" ? 0 : 1) &&
                    filesToHide.findIndex(name => file.Key.indexOf(name) > -1) === -1;
            }

            return file.Key.indexOf(this.state.currentPath) === 0 &&
                currentPathDepth === this.getFileDepth(file.Key) - (this.state.currentPath === "/" ? 0 : 1) &&
                filesToHide.findIndex(name => file.Key.indexOf(name) > -1) === -1;
        };

        return data.filter(checkFile);
    };

    getFileActions = () => {
        if (this.state.anchorEl) {
            const buttons: any[] = [];
            const fileKey = this.state.anchorEl.getAttribute("file-key");
            const fileHash = this.state.anchorEl.getAttribute("file-hash");
            const fileType = this.cleanFileName(fileKey).split(".");
            const fileExtension = fileType[fileType.length - 1];
            const objectData = this.getObjectData(fileKey);
            const objectKeyObj = {
                "object-key": fileKey,
                "object-hash": fileHash,
                "drive-key": objectData && objectData.drive_key
            };

            if (fileExtension === "JSON" || fileExtension === "json") {
                if (!this.isMissionsPath(fileKey)) {
                    if (objectData && objectData.drive_key && this.canUserGoogleSheet(fileKey)) {
                        buttons.push(<MenuItem onClick={this.openSheet} {...objectKeyObj} key="google-sheet-key">
                            Edit Google sheet
                        </MenuItem>);
                    } else {
                        buttons.push(<MenuItem onClick={this.editFile} {...objectKeyObj} key="edit-key">
                            Edit
                        </MenuItem>);
                    }
                }

                buttons.push(<MenuItem onClick={this.downloadJson} {...objectKeyObj} key="download-json-key">
                    Download as JSON
                </MenuItem>);
            }

            if (!fileExtension || fileExtension.length === 0) {
                buttons.push(<MenuItem onClick={this.exportFolderContent} {...objectKeyObj} key="export-content-key">
                    Export folder content
                </MenuItem>);
            }

            buttons.push(<MenuItem onClick={this.deleteObject} {...objectKeyObj} key="delete-key">
                Delete
            </MenuItem>);

            return buttons;
        }

        return null;
    };

    getPathIcon = (file) => {
        if (this.pathIsFolder(file.Key)) {
            return <FolderIcon />;
        }

        return <InsertDriveFileIcon />;
    };

    getFileSize = (file) => {
        if (this.getFileType(file) === "Folder") {
            return null;
        }

        return this.bytesToSize(file.Size);
    };

    getFileType = (file) => {
        const name = this.cleanFileName(file.Key);
        const fileType = name.split(".");
        const fileExtension = fileType[fileType.length - 1];

        if (fileExtension) {
            return fileExtension.toUpperCase();
        }

        return "Folder";
    };

    getFileGameId = (file) => {
        if (this.pathIsFolder(file.Key)) {
            return null;
        }

        const name = this.cleanFileName(file.Key);
        return name.split(".")[0];
    };

    getFileName = (file): string => {
        if (this.pathIsFolder(file.Key)) {
            const folderName = file.Key.split("/");
            return Helpers.capitalizeFirstLetter(folderName[folderName.length - 2].replace("_", " "));
        }

        let name = this.cleanFileName(file.Key);
        let fileType = name.split(".");

        name = fileType[0];
        fileType = fileType[fileType.length - 1].toUpperCase();

        // Rename file name
        if (this.state.bundleData && fileType) {
            const nameRename = this.state.bundleData.objects.find(object => object.key === file.Key);

            if (nameRename) {
                name = nameRename.name;
            }
        }

        return name;
    };

    refreshList = () => {
        // Load bundle data and then load bundle content
        this.loadBundleData(() => {
            this.loadFolderContent();
        });
    };

    isMissionsPath = (path = null) => {
        if (!path) {
            return this.state.currentPath.indexOf("missions/") !== -1;
        }

        return path.indexOf("missions/") !== -1;
    };

    isWeaponsPath = () => this.state.currentPath.indexOf("weapons/") !== -1;

    isArmorsPath = () => this.state.currentPath.indexOf("armors/") !== -1;

    isBuildingsPath = () => this.state.currentPath.indexOf("buildings/") !== -1;

    getMissionType = () => {
        const parameters = this.state.currentPath.split("/");
        parameters.pop();

        return parameters[parameters.length - 1];
    };

    changeFileSource(e) {
        this.setState({fileSource: e.target.value}, () => {
            this.loadFolderContent();
        });
    }

    renderSourceSelect(key: string) {
        return <FormControl variant="outlined" fullWidth={true} size="small" key={key}>
            <Select
                labelId="source-select"
                value={this.state.fileSource}
                onChange={e => this.changeFileSource(e)}
            >
                <MenuItem value="game">Game files</MenuItem>
                <MenuItem value="server">Server files</MenuItem>
            </Select>
        </FormControl>;
    }

    /**
     * Generate breadcrumbs
     */
    getBreadcrumbs() {
        // Split url and remove empty elements
        const paths = this.state.currentPath.split("/");
        paths.splice(-1, 1);

        if (paths[0] !== "") {
            paths.unshift("");
        }

        return <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            arial-label="Breadcrumb"
            className="bundle-breadcrumbs"
        >
            {paths.map((item, index) => {
                // Root item
                if (index === 0) {
                    // If only item in stack
                    if (index === paths.length - 1) {
                        return this.renderSourceSelect(item + index);
                    }

                    return <Link href={Helpers.fullUrl(item)} onClick={this.handleBreadcrumbLink} key={item + index}>
                        {this.state.fileSource === "game" ? "Game files" : "Server files"}
                    </Link>;
                }

                // If last item in stack
                if (index === paths.length - 1) {
                    if (index === 0) {
                        return this.renderSourceSelect(item + index);
                    }

                    return <Typography color="textPrimary" key={item + index}>
                        {Helpers.capitalizeFirstLetter(item)}
                    </Typography>;
                }

                return <Link
                    href={Helpers.fullUrl(paths.slice(0, index + 1).join("/"))}
                    onClick={this.handleBreadcrumbLink}
                    key={item + index}
                >
                    {Helpers.capitalizeFirstLetter(item)}
                </Link>;
            })}
        </Breadcrumbs>;
    }

    updateSearchKeyword = (e) => {
        const value = e.target?.value?.length === 0 ? null : e.target.value;

        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        // @ts-ignore
        this.timeout = setTimeout(() => {
            this.setState({
                searchKeyword: value,
            });
        }, 300);
    };

    bytesToSize = (bytes) => {
        const sizes = ["bytes", "KB", "MB", "GB", "TB"];
        if (bytes === 0) {
            return "0 bytes";
        }
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)) as any, 10);
        return `${Math.round(bytes / Math.pow(1024, i))} ${sizes[i]}`;
    };

    cleanFileName = (name) => name.split("/").pop();

    onPullFromServer = async () => {
        this.setState({loading: true});

        const url = `${Config.getInstance.apiUrl}/api/bundle/pull`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        const response = await axios.post(url, {}, {headers});

        const success = response.data.success;

        if (success) {
            PopupMessage.success("Files pulled from server");
        } else {
            PopupMessage.error("Something went wrong");
        }

        this.setState({loading: false});
    }

    render() {
        // If we need a redirect to main bundle page
        if (this.state.redirect) {
            return <Redirect to="/bundles" />;
        }

        const {classes} = this.props;

        return <div className="contentPadding">
            <Paper className="root" elevation={0}>
                <div style={{float: "left", padding: "15px 22px 15px 22px", width: "100%"}}>
                    <div className={classes.title}>
                        {this.getBreadcrumbs()}
                    </div>
                    <div className={classes.actions}>
                        <div style={{display: "inline-block", marginLeft: 10}}>
                            <Button
                                variant="contained"
                                onClick={() => this.onPullFromServer()}
                            >Pull files</Button>
                        </div>

                        <div style={{display: "inline-block", marginLeft: 10}}>
                            <TextField
                                placeholder="Search…"
                                onKeyUp={this.updateSearchKeyword}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined"
                                size="small"
                            />
                        </div>

                        {this.state.rootPage && <div style={{display: "inline-block", marginLeft: 10}}>
                            <Tooltip title="Generate fingerprint" placement="top-end">
                                <IconButton aria-label="Generate fingerprint" onClick={this.generateFingerprint}>
                                    <FingerprintIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </div>}

                        <div style={{display: "inline-block", marginLeft: 10}}>
                            <NewFolderModalForm
                                buttonText="New folder"
                                refreshParent={() => this.refreshList()}
                                currentDirectory={this.state.currentPath}
                                activeBundleId={this.state.bundleId}
                            />
                        </div>

                        {!this.state.rootPage && <div style={{display: "inline-block", marginLeft: 10}}>
                            <NewFileModalForm
                                buttonText="Upload"
                                refreshParent={() => this.refreshList()}
                                currentDirectory={this.state.currentPath}
                            />
                        </div>}
                    </div>
                </div>

                {this.state.loading ? <TableRow key="loading-row">
                    <TableCell colSpan={5}>
                        {
                            Helpers.renderSkeletonRows(5, 100)
                        }
                    </TableCell>
                    </TableRow> : 
                    <div style={{float: "left", width: "100%"}}>
                        {this.formatTableBody(this.state.data)}
                    </div>
                }

            </Paper>
        </div>;
    }
}

const styles: any = theme => ({
    table: {
        minWidth: 700,
    },
    progress: {
        margin: 16,
    },
    title: {
        flex: "0 0 auto",
        float: "left",
    },
    actions: {
        color: theme.palette.text.secondary,
        float: "right",
        display: "flex",
        alignItems: "center",
        verticalAlign: "middle"
    },
    tableRow: {
        cursor: "pointer",
    },
    inputRoot: {
        color: "inherit",
    },
});

export const BundleExplorer = withStyles(styles)(BundleExplorerMain);
